import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { fetchUserDetails } from "../apis/user.api";

// Strict role guard. Unlike ProtectedRoute (which uses hasPermission("admin"), a permission that the
// role matrix also grants to "tech"), this checks the user's actual role (permission_name) against an
// explicit allow-list, so tech and everyone else are excluded. Role-based, so it works whether or not
// the user has an individual permission set seeded. Fetches fresh like ProtectedRoute and shows a
// spinner until the role is known (so it never redirects an allowed user prematurely on first load).
// Defaults to admin-only; pass `roles` to widen (e.g. Delhivery adds "delivery_team").
const AdminRoute = ({
  children,
  roles = ["admin"],
}: {
  children: any;
  roles?: string[];
}) => {
  const [role, setRole] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    fetchUserDetails()
      .then((res) =>
        setRole(
          res?.branch?.user_permission?.permission_name ??
            localStorage.getItem("user_role")
        )
      )
      .catch(() => setRole(localStorage.getItem("user_role")));
  }, []);

  if (role === undefined) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return role && roles.includes(role) ? children : <Navigate to={"/user-profile"} />;
};

export default AdminRoute;
